import type { Components, Theme } from '@mui/material/styles'

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: {
      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },
    },
  },
  defaultProps: {
    // Use a custom icon with 1px border
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="currentColor" strokeWidth="1"/>
      </svg>
    ),
  },
}
